import React, {FC} from 'react';
import LocationPriceInfoBoxBase from './LocationPriceInfoBoxBase';
import {IInfoBox} from "./interfaces";

const InstantApprovalInfoBox: FC<IInfoBox> = (props) => {
  const { formattedPrice, onClick, listHover} = props;
  return <LocationPriceInfoBoxBase formattedPrice={formattedPrice}
    onClick={onClick}
    severity={'success'}
    listHover={listHover}
  />
}

export default InstantApprovalInfoBox;
